import api from './api';

// Projetos de croquis
export const getAllProjects = async (filters = {}) => {
  try {
    const response = await api.get('/sketch/projects', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar projetos:', error);
    throw error;
  }
};

export const getProjectById = async (id) => {
  try {
    const response = await api.get(`/sketch/projects/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar projeto:', error);
    throw error;
  }
};

export const createProject = async (projectData) => {
  try {
    const response = await api.post('/sketch/projects', projectData);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar projeto:', error);
    throw error;
  }
};

export const updateProject = async (id, projectData) => {
  try {
    const response = await api.put(`/sketch/projects/${id}`, projectData);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar projeto:', error);
    throw error;
  }
};

export const deleteProject = async (id) => {
  try {
    const response = await api.delete(`/sketch/projects/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao deletar projeto:', error);
    throw error;
  }
};

// Elementos do croqui
export const saveElements = async (projectId, elements) => {
  try {
    const response = await api.post(`/sketch/projects/${projectId}/elements`, { elements });
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar elementos:', error);
    throw error;
  }
};

// Snapshot de imagem do croqui
export const saveSnapshot = async (projectId, dataUrl) => {
  try {
    const response = await api.post(`/sketch/projects/${projectId}/snapshot`, { dataUrl });
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar imagem do croqui:', error);
    throw error;
  }
};

// Templates de módulos
export const getModuleTemplates = async (filters = {}) => {
  try {
    const response = await api.get('/sketch/templates', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar templates:', error);
    throw error;
  }
};
